"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleAttributeState = exports.AltTextAttributeState = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var classnames_1 = __importDefault(require("classnames"));
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var AltTextAttributeState;
(function (AltTextAttributeState) {
    AltTextAttributeState["Empty"] = "";
})(AltTextAttributeState || (exports.AltTextAttributeState = AltTextAttributeState = {}));
var RoleAttributeState;
(function (RoleAttributeState) {
    RoleAttributeState["Presentation"] = "presentation";
    RoleAttributeState["Empty"] = "";
})(RoleAttributeState || (exports.RoleAttributeState = RoleAttributeState = {}));
var c = (0, BemBuilder_1.default)("alt-text-panel");
var AltTextPanel = (function (_super) {
    __extends(AltTextPanel, _super);
    function AltTextPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.isImageDecorative = _this.props.role === RoleAttributeState.Presentation || false;
        _this.setImageIsDecorative = function () {
            _this.isImageDecorative = !_this.isImageDecorative;
            _this.props.updateAltText(_this.props.alt, _this.isImageDecorative);
        };
        _this.setAltText = function (value) {
            _this.isImageDecorative = false;
            _this.props.updateAltText(value, _this.isImageDecorative);
        };
        return _this;
    }
    AltTextPanel.prototype.render = function () {
        var _this = this;
        var altTextHelpContent = "Alt text helps people with impaired vision understand the contents of the image. Good alt text is concise and describes what the image is communicating in this context.";
        return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s" },
            react_1.default.createElement(kaleidoscope_1.Expandable, { expanded: !this.isImageDecorative }, function (_a) {
                var expandableElementRef = _a.expandableElementRef;
                return (react_1.default.createElement("div", { ref: expandableElementRef, className: (0, classnames_1.default)(c("alt-text-container")) },
                    react_1.default.createElement(kaleidoscope_2.TextInput, { multiline: true, label: "Alt Text", size: kaleidoscope_2.TextInputSize.Small, theme: kaleidoscope_2.TextInputTheme.Dark, value: _this.props.alt, onChange: function (e) { return _this.setAltText(e); } }),
                    react_1.default.createElement(kaleidoscope_2.Tooltip, { size: kaleidoscope_2.TooltipSize.Large, content: altTextHelpContent, targetClassName: c("help") },
                        react_1.default.createElement(icons_1.Help, { className: c("help", "icon"), size: icons_1.IconSize.Small }))));
            }),
            react_1.default.createElement(kaleidoscope_1.Stack, { className: (0, classnames_1.default)(c("decorative-image-container")) },
                react_1.default.createElement(kaleidoscope_2.Toggle, { label: "Image is decorative", value: this.isImageDecorative, theme: "dark", onChange: function () { return _this.setImageIsDecorative(); } }),
                react_1.default.createElement(kaleidoscope_2.Text, { size: "xs", theme: "dark" }, "Decorative images that don\u2019t convey meaning don\u2019t require alt text"))));
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AltTextPanel.prototype, "isImageDecorative", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AltTextPanel.prototype, "setImageIsDecorative", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AltTextPanel.prototype, "setAltText", void 0);
    AltTextPanel = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], AltTextPanel);
    return AltTextPanel;
}(react_1.default.Component));
exports.default = AltTextPanel;
